// A rough remaining time for a running or planned job, without an approximation mark: the caller's
// own copy says how sure it is. Null when there is nothing honest to show, so the caller decides
// between hiding the label and its own placeholder.
export function formatDuration(seconds: number | null | undefined): string | null {
  if (seconds == null || !isFinite(seconds) || seconds <= 0 || seconds > 60 * 60 * 24 * 365) return null;
  if (seconds < 60) return `${Math.round(seconds)} s`;
  if (seconds < 3600) return `${Math.round(seconds / 60)} min`;
  if (seconds < 86400) return `${Math.round(seconds / 3600)} h`;
  return `${Math.round(seconds / 86400)} d`;
}
